<p-dialog #editFormElementModal modal="true" [(visible)]="showModal" [closable]="false" styleClass="atlas-dialog-m" [focusOnShow]="false">
  <ng-template pTemplate="header">
    <div>
      <h3>
        {{ 'common.edit' | translate | titlecase }} {{ 'common.form' | translate | titlecase }}
        {{ 'common.element' | translate | titlecase }}
      </h3>
      <h4 *ngIf="selectedFormElement.Field.FieldGroupType == fieldGroupTypes.MainContactFields">
        {{ 'forms.form-builder.main-contact-label' | translate | titlecase }}
      </h4>
      <h4 *ngIf="selectedFormElement.Field">{{ selectedFormElement.Field.DisplayName }}</h4>
    </div>
  </ng-template>
  <div>
    <div
      *ngIf="selectedFormElement.ElementTypeId < 7 || selectedFormElement.ElementTypeId == 15 || selectedFormElement.ElementTypeId == 17"
    >
      <div class="form-row">
        {{ 'common.label' | translate | titlecase }} {{ 'common.text' | translate | titlecase }}:
        <input class="form-control" type="text" [(ngModel)]="selectedFormElement.LabelText" />
      </div>
    </div>

    <div *ngIf="selectedFormElement.ElementTypeId < 7 || selectedFormElement.ElementTypeId == 15">
      <div class="form-row">
        {{ 'common.help' | translate | titlecase }} {{ 'common.text' | translate | titlecase }}:
        <input class="form-control" type="text" [(ngModel)]="selectedFormElement.HelpText" />
      </div>
    </div>

    <div *ngIf="selectedFormElement.Field.FieldType == 85 && selectedFormElement.Field.FieldValue">
      <div class="form-row" *ngIf="!useArc">
        {{ 'common.revenue.price' | translate | titlecase }}
        <input class="form-control" type="number" placeholder="potentialFieldPrice" [(ngModel)]="selectedFieldPrice" />
      </div>
      <div class="form-row" *ngIf="useArc">
        {{ 'forms.form-builder.revenue.price-is-auto-calculated' | translate | titlecase }}
        <p class="col-sm-offset-1" *ngFor="let rev of selectedFormElement.Field.RevenueInfo">
          {{ rev.ArcInfo.Descr }}
        </p>
      </div>
      <div class="form-row" *ngFor="let rev of selectedFormElement.Field.RevenueInfo">
        <p *ngIf="rev.IsProrated">
          {{ 'forms.form-builder.revenue.price-is-prorated' | translate | titlecase }}
          {{ rev.ProrationMonth + 1 + '-1-1900' | date: 'MMMM' }}
        </p>
      </div>
    </div>

    <div *ngIf="selectedFormElement.Field && fieldCanBeRequired">
      <div class="form-row">
        <label>
          <input type="checkbox" [(ngModel)]="selectedFormElement.Required" />
          {{ 'common.required' | translate | titlecase }}
        </label>
      </div>
    </div>

    <div
      *ngIf="
        selectedFormElement.ElementTypeId == 1 &&
        selectedFormElement.Field.AvailableValues.length <= 0 &&
        selectedFormElement.Field.IsSensitive == false
      "
    >
      <div class="form-row">
        {{ 'common.placeholder' | translate | titlecase }} {{ 'common.text' | translate | titlecase }}:
        <input class="form-control" type="text" [(ngModel)]="selectedFormElement.Placeholder" />
      </div>
    </div>

    <div *ngIf="selectedFormElement.ElementTypeId == 2">
      <div class="form-row">
        <label>
          <input type="checkbox" [(ngModel)]="selectedFormElement.IsMutuallyExclusive" (ngModelChange)="onIsMutuallyExclusiveChanged()" />
          {{ 'common.mutually' | translate | titlecase }} {{ 'common.exclusive' | translate | titlecase }}
        </label>
      </div>

      <div class="form-row" *ngIf="selectedFormElement.IsMutuallyExclusive">{{ 'common.with' | translate | titlecase }}:</div>

      <div class="form-row" *ngIf="selectedFormElement.IsMutuallyExclusive">
        <div *ngFor="let availElement of this.selectedFormElement.MutuallyExclusiveFormElements; index as i">
          <label>
            <input type="checkbox" [(ngModel)]="this.selectedFormElement.MutuallyExclusiveFormElements[i].Selected" />
            {{ availElement.Name }}
          </label>
        </div>
      </div>
    </div>

    <div *ngIf="selectedFormElement.ElementTypeId == 3"></div>

    <div *ngIf="selectedFormElement.ElementTypeId == 4">
      <div class="form-row">{{ 'common.items' | translate | titlecase }}:</div>
      <div class="form-row">
        <div class="col-sm-6">{{ 'common.name' | translate | titlecase }}:</div>
        <div class="col-sm-6">{{ 'common.value' | translate | titlecase }}:</div>
      </div>
      <div class="form-row">
        <div class="col-sm-6">
          <input type="text" [(ngModel)]="value.ProposedItemName" class="form-control" />
        </div>
        <div class="col-sm-6">
          <input type="number" class="form-control" min="0" [(ngModel)]="value.ProposedItemValue" />
        </div>
      </div>
      <div class="form-row">
        <div class="col-sm-6">
          <button pButton type="button" class="atlas-btn atlas-btn-primary" (click)="addItemDropdownListInteger(value)">
            {{ 'common.add' | translate | titlecase }} {{ 'common.item' | translate | titlecase }}
          </button>
        </div>
        <div class="col-sm-6">
          <button pButton type="button" class="atlas-btn atlas-btn-primary" (click)="removeItemDropdownListInteger(value)">
            {{ 'common.remove' | translate | titlecase }} {{ 'common.selected' | translate | titlecase }}
          </button>
        </div>
      </div>

      <div class="form-row">
        <select size="4" class="full-width" [(ngModel)]="selectedFormElement.SelectedValue">
          <option *ngFor="let item of selectedFormElement.Items" [ngValue]="item.value">
            {{ item.name + ' (' + item.value.toString() + ')' }}
          </option>
        </select>
      </div>
    </div>

    <div *ngIf="selectedFormElement.ElementTypeId == 5"></div>

    <div *ngIf="selectedFormElement.ElementTypeId == 6"></div>

    <div *ngIf="selectedFormElement.ElementTypeId == 7 && htmlText != null">
      <div class="form-row">
        {{ 'common.text' | translate | titlecase }}:
        <wl-wysiwyg-editor [showHtmlTemplates]="false" [disableImageSelector]="true" [(ngModel)]="htmlText" [compact]="true"></wl-wysiwyg-editor>
      </div>
    </div>

    <div *ngIf="selectedFormElement.ElementTypeId == 8">
      <div class="form-row">
        {{ 'common.header' | translate | titlecase }} {{ 'common.text' | translate | titlecase }}:
        <input class="form-control" type="text" [(ngModel)]="selectedFormElement.HeaderText" />
      </div>
      <div class="form-row">
        {{ 'common.sub' | translate | titlecase }}{{ 'common.header' | translate | titlecase }} {{ 'common.text' | translate | titlecase }}:
        <input class="form-control" type="text" [(ngModel)]="selectedFormElement.SubHeaderText" />
      </div>
    </div>

    <div [hidden]="selectedFormElement.ElementTypeId != 9">
      <wl-form-builder-profile-edit-element #relatedProfileSettingsElement></wl-form-builder-profile-edit-element>
    </div>

    <div [hidden]="selectedFormElement.ElementTypeId != 19">
      <wl-form-builder-profile-edit-element [isOrg]="true" #relatedOrgSettingsElement></wl-form-builder-profile-edit-element>
    </div>

    <div [hidden]="selectedFormElement.ElementTypeId != 11">
      <wl-form-builder-listing-edit-element #listingSettingsElement></wl-form-builder-listing-edit-element>
    </div>

    <div class="col-sm-12" [hidden]="selectedFormElement.ElementTypeId != 10">
      <wl-form-builder-social-media-edit-element #socialMediaSettingsElement></wl-form-builder-social-media-edit-element>
    </div>

    <div class="col-sm-12" [hidden]="selectedFormElement.ElementTypeId != 16">
      <wl-form-builder-membership-level-edit-element #membershipLevelSettingsElement></wl-form-builder-membership-level-edit-element>
    </div>

    <div [hidden]="selectedFormElement.ElementTypeId != 13">
      <wl-form-builder-profile-address-edit-element #profileAddressSettingsElement></wl-form-builder-profile-address-edit-element>
    </div>

    <div [hidden]="selectedFormElement.ElementTypeId != 14">
      <wl-form-builder-hba-profile-data-edit-element #hbaProfileDataSettingsElement></wl-form-builder-hba-profile-data-edit-element>
    </div>

    <div class="form-row" [hidden]="selectedFormElement.ElementTypeId != 17">
      <wl-form-builder-affiliation-checklist-edit-element
        #affiliationCodeSettingsElement
      ></wl-form-builder-affiliation-checklist-edit-element>
    </div>

    <div class="form-row" [hidden]="selectedFormElement.ElementTypeId != 18">
      <wl-form-builder-upload-file-edit-element #fileUploadSettingsElement></wl-form-builder-upload-file-edit-element>
    </div>

    <div [hidden]="selectedFormElement.ElementTypeId != 20">
      <wl-form-builder-email-optin-edit-element #emailOptInSettingsElement></wl-form-builder-email-optin-edit-element>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <button
      pButton
      type="button"
      class="atlas-btn atlas-btn-primary"
      icon="pi pi-save"
      [label]="'common.update' | translate | titlecase"
      (click)="close()"
    ></button>
    <cancel-button [label]="'common.cancel' | translate | titlecase" (onClick)="cancel()"> </cancel-button>
  </ng-template>
</p-dialog>
